import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';

export const StyledCTA = styled.div`
  background: ${themeGet('color.colorBlue90')};
  color: ${themeGet('color.colorWhite')};
  text-align: center;
  padding: ${themeGet('scale.scaleUp04')};
  padding-top: ${themeGet('scale.scaleUp07')};
  border-radius: ${themeGet('scale.scaleDown04')};
  box-shadow: 0 0 1px 0 rgba(68, 95, 140, 0.45),
    0 10px 29px -8px rgba(44, 74, 125, 0.34);

  > figure {
    grid-area: img;
    display: none;
  }

  > div:nth-of-type(1) {
    grid-area: content;
  }

  > div:nth-of-type(2) {
    grid-area: btn;
  }

  svg {
    width: 100%;
    display: block;
  }

  h4 {
    font-size: ${themeGet('scale.scaleUp04')};
    margin-bottom: ${themeGet('scale.scaleDown03')};
    color: ${themeGet('color.colorWhite')};
  }

  p {
    font-size: ${themeGet('scale.scaleBase')};
    margin-bottom: ${themeGet('scale.scaleBase')};
    color: ${themeGet('color.colorWhite')};
  }

  @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
    display: grid;
    align-items: center;
    grid-template-columns: 133px auto;
    grid-template-areas: 'img content' 'img btn';
    grid-column-gap: ${themeGet('scale.scaleUp09')};
    text-align: left;
    padding: ${themeGet('scale.scaleUp08')} ${themeGet('scale.scaleUp09')};

    figure {
      display: block;
    }

    .btn {
      width: auto;
    }

    h4 {
      font-size: ${themeGet('scale.scaleUp05')};
    }

    p {
      font-size: ${themeGet('scale.scaleUp01')};
      margin-bottom: ${themeGet('scale.scaleUp03')};
    }
  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    grid-template-columns: 101px auto max-content;
    grid-template-areas: 'img content btn';
    grid-column-gap: ${themeGet('scale.scaleUp12')};
    padding: ${themeGet('scale.scaleUp10')} ${themeGet('scale.scaleUp12')};

    h4 {
      font-size: ${themeGet('scale.scaleUp07')};
    }

    p {
      font-size: ${themeGet('scale.scaleUp02')};
      margin: 0;
    }
  }
`;

export default StyledCTA;
